<template>
    <div class="music-player">
        <audio ref="audio" @loadedmetadata="setTime" @timeupdate="handleTime">
        </audio>
        <Attachment can-remove
            :fileName="fileName"
            :error="hasError"
            @drop="handleFile"
            @upload="handleFile"
            @remove="handleRemove"
        >
            <span class="filename">File name: {{ fileName }}</span>
            <div class="music-controls">
                <span>{{ time }}</span>
                <span class="control" @click.stop.prevent="control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g transform="translate(-9.413 -11.415)"><path d="M16.413,11.94a6.475,6.475,0,1,1-6.475,6.475,6.482,6.482,0,0,1,6.475-6.475m0-.525a7,7,0,1,0,7,7,7,7,0,0,0-7-7Z"/><path d="M41.605,42.938l3.325-1.92a.35.35,0,0,0,0-.606l-3.325-1.92a.35.35,0,0,0-.525.3v3.839a.35.35,0,0,0,.525.3Z" transform="translate(-26.125 -22.3)"/></g></svg>
                </span>
                <span>{{ duration }}</span>
            </div>
            <AppProgress :progress="progress" />
        </Attachment>
    </div>
</template>

<script>
import AppProgress from '@/components/AppProgress'
import Attachment from '@/components/Attachment'
import {
	readFileData,
	formatTime,
	validMusicFormat,
	rawMusicPlayer
} from '@/utils/helpers'

export default {
	props: {
		error: String
	},
	data () {
		return {
			sound: null,
			time: 0,
			duration: 0,
			progress: 0,
			hasAudio: false,
			fileName: null,
			hasError: false
		}
	},
	watch: {
		error (val) {
			this.hasError = !!val
		}
	},
	methods: {
		async handleFile (e) {
			this.hasError = false
			const files = e.target.files || e.dataTransfer.files
			if (!files.length) return
			const name = files[0].name
			if (!validMusicFormat.includes(name.split('.').pop().toLowerCase())) {
				this.hasAudio && this.handleRemove(false)
				this.hasError = true
				return
			}
			this.hasAudio = true
			const music = await readFileData(files[0])
			this.$refs.audio.src = music
			this.fileName = name
			this.$emit('input', files[0])
		},
		setTime () {
			const { currentTime, duration } = this.$refs.audio
			this.time = formatTime(currentTime)
			this.duration = formatTime(duration)
			this.progress = Math.floor((currentTime / duration) * 100) || 0
		},
		handleTime () {
			this.setTime()
		},
		handleRemove (emit = true) {
			Object.keys(rawMusicPlayer).forEach(key => {
				this[key] = rawMusicPlayer[key]
			})
			this.$refs.audio.src = null
			this.$refs.audio.pause()

			emit && this.$emit('input')
		},
		control () {
			if (this.$refs.audio.paused) {
				this.$refs.audio.play()
			} else this.$refs.audio.pause()
		}
	},
	components: {
		AppProgress,
		Attachment
	}
}
</script>

<style lang="scss" scoped>
.data-container {
    height: 300px;
    align-items: center;
}

.music-player {
    width: 100%;
}

h3 {
    color: $primary;
}

</style>
